(function () {
  if (typeof window === 'undefined') return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Scroll reveal ---
  var revealIO = null;
  var staggerMap = new WeakMap();
  function attachReveal(node) {
    if (!node || node.dataset.fbObs) return;
    node.dataset.fbObs = '1';
    if (reduced || !revealIO) { node.classList.add('is-in'); return; }
    revealIO.observe(node);
  }
  function initReveal() {
    var nodes = document.querySelectorAll('[data-fb-reveal], .product-card-wrapper');
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      observeNewCards();
      return;
    }
    // Stagger by column-index inside the parent grid <ul>, derived from computed grid-template-columns
    var staggerMap = new WeakMap();
    var colCountCache = new WeakMap();
    function colsOf(grid) {
      if (colCountCache.has(grid)) return colCountCache.get(grid);
      var w = window.innerWidth;
      var cls = grid.className || '';
      var pick = function (re) { var m = cls.match(re); return m ? parseInt(m[1], 10) : null; };
      var n;
      if (w >= 990) {
        n = pick(/grid--(\d+)-col-desktop/) || pick(/grid--(\d+)-col-tablet/) || pick(/grid--(\d+)-col-tablet-down/);
      } else if (w >= 750) {
        n = pick(/grid--(\d+)-col-tablet(?!-down)/) || pick(/grid--(\d+)-col-tablet-down/) || pick(/grid--(\d+)-col-desktop/);
      } else {
        n = pick(/grid--(\d+)-col-tablet-down/) || pick(/grid--(\d+)-col-tablet/) || pick(/grid--(\d+)-col-desktop/);
      }
      if (!n || n < 1) {
        // Fallback: try grid-template-columns then default to 1
        var tpl = getComputedStyle(grid).gridTemplateColumns || '';
        n = tpl && tpl !== 'none' ? tpl.trim().split(/\s+/).length : 1;
      }
      colCountCache.set(grid, n);
      return n;
    }
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Lazy-compute stagger so it works for late-injected cards too
        if (!staggerMap.has(el) && el.classList.contains('product-card-wrapper')) {
          var item = el.closest('.grid__item') || el.parentElement;
          var grid = item ? item.parentElement : null;
          if (grid) {
            var idx = Array.prototype.indexOf.call(grid.children, item);
            if (idx >= 0) staggerMap.set(el, (idx % colsOf(grid)) * 90);
          }
        }
        var delay = staggerMap.get(el) || 0;
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        revealIO.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(attachReveal);
    observeNewCards();
  }

  function observeNewCards() {
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('.product-card-wrapper, [data-fb-reveal]')) attachReveal(n);
          if (n.querySelectorAll) n.querySelectorAll('.product-card-wrapper, [data-fb-reveal]').forEach(attachReveal);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // --- Hero word reveal + scroll parallax ---
  function initHero() {
    var heroes = document.querySelectorAll('.hero-split');
    heroes.forEach(function (hero) {
      hero.setAttribute('data-fb-hero', '');
      var heading = hero.querySelector('.hero-split__heading');
      if (heading && !heading.dataset.fbWrapped) {
        heading.dataset.fbWrapped = '1';
        wrapWords(heading, 0);
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { hero.classList.add('is-ready'); });
      });

      if (reduced) return;
      var media = hero.querySelector('.hero-split__media');
      if (!media) return;
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = hero.getBoundingClientRect();
          var y = Math.max(-60, Math.min(60, rect.top * -0.08));
          hero.style.setProperty('--fb-hero-y', y.toFixed(1) + 'px');
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function wrapWords(root, startDelay) {
    var counter = { i: 0 };
    walk(root);
    function walk(node) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (n) {
        if (n.nodeType === 3) {
          var text = n.nodeValue;
          if (!text || !text.trim()) return;
          var frag = document.createDocumentFragment();
          var parts = text.split(/(\s+)/);
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) {
              frag.appendChild(document.createTextNode(p));
            } else {
              var span = document.createElement('span');
              span.className = 'fb-word';
              span.style.setProperty('--fb-d', (startDelay + counter.i * 70) + 'ms');
              span.textContent = p;
              frag.appendChild(span);
              counter.i++;
            }
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          walk(n);
        }
      });
    }
  }

  // --- Marquee: duplicate group for seamless loop ---
  function initMarquee() {
    document.querySelectorAll('.fb-marquee').forEach(function (m) {
      var track = m.querySelector('.fb-marquee__track');
      if (!track || track.dataset.fbInit) return;
      track.dataset.fbInit = '1';
      var group = track.querySelector('.fb-marquee__group');
      if (!group) return;
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initHero();
    initMarquee();
    initReveal();
  });
})();
